import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { deleteField, doc, getDoc, writeBatch } from "firebase/firestore";
import { updateProjectLastModified } from "@comp/project-last-modified/actions";
import { openSimpleModal } from "@comp/modal/actions";
import { openSnackbar } from "@comp/snackbar/actions";
import { SnackbarType } from "@comp/snackbar/types";
import { database, targets as targetsCollReference } from "@config/firestore";
import { SET_SELECTED_TARGET, UPDATE_ALL_TARGETS_LOCALLY } from "./types";
export var setSelectedTarget = function setSelectedTarget(projectUid, selectedTarget) {
    return /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(dispatch) {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1)
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch({
                                type: SET_SELECTED_TARGET,
                                selectedTarget: selectedTarget,
                                projectUid: projectUid
                            });
                        case 1:
                        case "end":
                            return _context.stop();
                    }
            }, _callee);
        }));
        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();
};
export var showTargetsConfigDialog = function showTargetsConfigDialog() {
    return /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(dispatch) {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1)
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dispatch(openSimpleModal("target-controls", {}));
                        case 1:
                        case "end":
                            return _context2.stop();
                    }
            }, _callee2);
        }));
        return function (_x2) {
            return _ref2.apply(this, arguments);
        };
    }();
};
export var updateAllTargetsLocally = function updateAllTargetsLocally(dispatch, defaultTarget, projectUid, targets) {
    return dispatch({
        type: UPDATE_ALL_TARGETS_LOCALLY,
        defaultTarget: defaultTarget,
        projectUid: projectUid,
        targets: targets
    });
};
export var downloadTargetsOnce = function downloadTargetsOnce(projectUid) {
    return /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(dispatch) {
            var projTargetsReference, data;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1)
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return getDoc(doc(targetsCollReference, projectUid));
                        case 2:
                            projTargetsReference = _context3.sent;
                            if (!projTargetsReference.exists()) {
                                _context3.next = 9;
                                break;
                            }
                            data = projTargetsReference.data();
                            _context3.t0 = data;
                            if (!_context3.t0) {
                                _context3.next = 9;
                                break;
                            }
                            _context3.next = 9;
                            return updateAllTargetsLocally(dispatch, data.defaultTarget, projectUid, data.targets);
                        case 9:
                        case "end":
                            return _context3.stop();
                    }
            }, _callee3);
        }));
        return function (_x3) {
            return _ref3.apply(this, arguments);
        };
    }();
};
export var saveChangesToTarget = function saveChangesToTarget(projectUid, targets, defaultTarget, onSuccessCallback) {
    return /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(dispatch) {
            var targetsReference, batch;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1)
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            targetsReference = doc(targetsCollReference, projectUid);
                            batch = writeBatch(database);
                            console.log({
                                targets: targets,
                                defaultTarget: defaultTarget
                            });
                            _context4.prev = 3;
                            batch.set(targetsReference, {
                                targets: deleteField()
                            }, {
                                merge: true
                            });
                            batch.set(targetsReference, {
                                targets: targets,
                                defaultTarget: defaultTarget
                            }, {
                                merge: true
                            });
                            _context4.next = 8;
                            return batch.commit();
                        case 8:
                            updateProjectLastModified(projectUid);
                            onSuccessCallback && onSuccessCallback();
                            _context4.next = 15;
                            break;
                        case 12:
                            _context4.prev = 12;
                            _context4.t0 = _context4["catch"](3);
                            dispatch(openSnackbar(_context4.t0.toString(), SnackbarType.Error));
                        case 15:
                        case "end":
                            return _context4.stop();
                    }
            }, _callee4, null, [[3, 12]]);
        }));
        return function (_x4) {
            return _ref4.apply(this, arguments);
        };
    }();
};
